<dialog
    #reviewDialog
    id="review-questions-dialog"
    class="m-auto w-full max-w-lg rounded-3xl border-0 bg-card p-0 text-foreground shadow-xl backdrop:bg-black/40"
    aria-labelledby="review-questions-title">
    <div class="relative flex flex-col gap-5 p-4">
        <button type="button" (click)="close()"
            class="btn-shout-fab-secondary absolute right-2 top-2" aria-label="Close">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="size-4" aria-hidden="true">
                <path d="M18 6 6 18" />
                <path d="m6 6 12 12" />
            </svg>
        </button>

        <div class="flex flex-col gap-2 pr-10">
            <h2 id="review-questions-title" class="m-0 text-2xl font-bold tracking-tight text-foreground">
                Review brief required
            </h2>
            <p class="m-0 text-sm leading-relaxed text-foreground">
                <strong class="font-semibold">{{ briefTitle() }}</strong> is processing.
                <strong class="font-semibold">{{ generalisedCount() }}</strong> of its
                <strong class="font-semibold">{{ totalCount() }}</strong>
                requirements need your context before you can activate.
            </p>
        </div>

        <div class="flex flex-col gap-3">
            <div class="flex items-baseline gap-2">
                <p class="m-0 text-5xl font-bold leading-none tracking-tight text-foreground">{{ totalCount() }}</p>
                <p class="m-0 text-sm text-muted-foreground">total requirements</p>
            </div>
            <div class="h-2 w-full overflow-hidden rounded-full bg-gray-200 dark:bg-white/15" role="progressbar"
                [attr.aria-valuenow]="generalisedCount()" aria-valuemin="0" [attr.aria-valuemax]="totalCount()"
                aria-label="Requirements that need context">
                <div class="h-full rounded-full bg-gradient-to-r from-fuchsia-500 to-fuchsia-700"
                    [style.width.%]="filledPercent()"></div>
            </div>
        </div>

        <div class="flex flex-col gap-3 border-t border-border pt-5">
            <div class="flex flex-wrap items-center justify-between gap-3">
                <div class="flex items-center gap-2">
                    <span class="size-2.5 shrink-0 rounded-full bg-fuchsia-500" aria-hidden="true"></span>
                    <h3 class="m-0 text-sm font-semibold text-foreground">Generalised questions</h3>
                </div>
                <div class="flex items-center gap-2">
                    <p
                        class="m-0 rounded-full bg-fuchsia-100 px-2.5 py-0.5 text-xs font-semibold uppercase tracking-wide text-fuchsia-700 dark:bg-fuchsia-500/15 dark:text-fuchsia-300">
                        Action needed
                    </p>
                    <p class="m-0 text-sm font-bold text-foreground">{{ generalisedCount() }}</p>
                </div>
            </div>
            <p class="m-0 text-sm leading-relaxed text-muted-foreground">
                Checks that apply to all of a creator's content rather than one video, like “Be interested in the
                healthy lifestyle”. Add the context SHOUT needs to apply each one before the brief can be activated.
            </p>
        </div>

        <div class="flex flex-col items-center gap-3 border-t border-border pt-5">
            <button type="button" (click)="reviewQuestions()"
                class="btn-shout btn-shout-md btn-shout-primary w-full justify-center">
                Review {{ generalisedCount() }} questions
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-4" aria-hidden="true">
                    <path d="M5 12h14" />
                    <path d="m12 5 7 7-7 7" />
                </svg>
            </button>
            <button type="button" (click)="skip()"
                class="btn-shout btn-shout-sm btn-shout-secondary review-questions-skip">
                Skip for now
            </button>
        </div>
    </div>
</dialog>
